/* eslint-disable no-console */
import { RenNetwork } from "@renproject/interfaces";
import { ConnectorEmitter, } from "@renproject/multiwallet-base-connector";
const isResults = (x) => x.results !== undefined;
const resultOrRaw = (x) => {
    if (isResults(x)) {
        return x.results;
    }
    return x;
};
export const ethNetworkToRenNetwork = (id) => {
    let decodedId = id;
    if (typeof id === "string") {
        try {
            decodedId = parseInt(id);
        }
        catch (e) {
            decodedId = Buffer.from(id.split("0x").pop() || "", "hex")[0];
        }
    }
    const network = {
        1: RenNetwork.Mainnet,
        42: RenNetwork.Testnet,
    }[decodedId];
    if (!network) {
        throw new Error("Unknown Ethereum network");
    }
    return network;
};
export class AbstractEthereumConnector {
    constructor({ debug = false, networkIdMapper = ethNetworkToRenNetwork, }) {
        this.supportsTestnet = true;
        this.networkIdMapper = ethNetworkToRenNetwork;
        this.networkIdMapper = networkIdMapper;
        this.debug = debug;
        this.emitter = new ConnectorEmitter(debug);
    }
    // Get the complete connector status in one call
    async getStatus() {
        if (this.debug)
            console.debug("getting status");
        return {
            account: await this.getAccount(),
            renNetwork: await this.getRenNetwork(),
            provider: await this.getProvider(),
        };
    }
    // Get default ethereum account
    async getAccount() {
        if (this.debug)
            console.debug("getting account");
        const account = resultOrRaw(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        await (await this.getProvider()).request({
            method: "eth_requestAccounts",
        }))[0];
        if (!account) {
            throw new Error("Not activated");
        }
        return account;
    }
    // Cast current ethereum network to Ren network version or throw
    async getRenNetwork() {
        if (this.debug)
            console.debug("getting chain");
        return this.networkIdMapper(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        await resultOrRaw((await this.getProvider())).request({
            method: "eth_chainId",
        }));
    }
}
